(function(){
  var STORAGE_KEY = 'savvy-suggestions-v1';
  var DISMISS_KEY = 'savvy-suggestions-dismissed';
  var MAX_HORSES = 3;
  var QUIZ_URL = '/pages/premier-performance#finder';
  var API_BASE = 'https://savvyshopify-ppzoho-production.up.railway.app';

  var root = document.querySelector('[data-savvy-sugg-root]');
  if (!root) return;

  var customerId = root.getAttribute('data-savvy-sugg-customer-id') || null;
  var customerEmail = root.getAttribute('data-savvy-sugg-customer-email') || null;

  try { if (sessionStorage.getItem(DISMISS_KEY)) return; } catch (e) {}

  // ── Load path: localStorage first, then fetch from Railway if the customer
  // is logged in and either localStorage is empty or Railway is fresher. ──
  var raw;
  try { raw = localStorage.getItem(STORAGE_KEY); } catch (e) { raw = null; }

  function boot(rawJson) {
    if (!rawJson) return;
    var data;
    try { data = JSON.parse(rawJson); } catch (e) { return; }
    if (!data) return;
    startWidget(data);
  }

  // Kick off the initial render from whatever's local. Then, if logged in,
  // race a fetch — hydrate if the server has something newer or if local
  // was empty.
  if (raw) boot(raw);

  if (customerId && window.fetch) {
    fetch(API_BASE + '/public/customer/quiz/' + encodeURIComponent(customerId), { credentials: 'omit' })
      .then(function(r){ return r.ok ? r.json() : null; })
      .then(function(remote) {
        if (!remote || !Array.isArray(remote.horses) || remote.horses.length === 0) return;
        var localData = null;
        try { localData = JSON.parse(localStorage.getItem(STORAGE_KEY) || 'null'); } catch (e) {}
        var localNewest = localData && Array.isArray(localData.horses)
          ? localData.horses.reduce(function(m, h){ return Math.max(m, h.savedAt || 0); }, 0)
          : 0;
        var remoteNewest = remote.horses.reduce(function(m, h){ return Math.max(m, h.savedAt || 0); }, 0);
        // Prefer remote if it's newer OR if local is empty
        if (remoteNewest > localNewest) {
          var hydrated = {
            version: 2,
            horses: remote.horses,
            activeIndex: typeof remote.activeIndex === 'number' ? remote.activeIndex : 0,
          };
          try { localStorage.setItem(STORAGE_KEY, JSON.stringify(hydrated)); } catch (e) {}
          // Remount the widget with the fresher data.
          root.removeAttribute('data-savvy-sugg-active');
          root.removeAttribute('data-savvy-sugg-open');
          boot(JSON.stringify(hydrated));
        }
      })
      .catch(function(){ /* offline / down — silently fall back to local */ });
  }

  if (!raw) return; // nothing to render synchronously; if the fetch above lands, it will boot then

  function startWidget(data) {

  // Migrate v1 (single-horse) → v2 array shape
  if (!Array.isArray(data.horses) && Array.isArray(data.picks)) {
    data = {
      version: 2,
      horses: [{ name: data.horseName || 'Horse 1', savedAt: data.savedAt || Date.now(), picks: data.picks }],
      activeIndex: 0,
    };
  }
  if (!Array.isArray(data.horses) || data.horses.length === 0) return;

  // Suppress on the quiz results screen — the customer's already looking at
  // the same information one section up.
  var onResults = document.querySelector('#finder [data-quiz-step="results"][data-active="true"]');
  if (onResults) return;

  root.setAttribute('data-savvy-sugg-active', 'true');

  var horses = data.horses;
  var activeIdx = typeof data.activeIndex === 'number' ? data.activeIndex : 0;
  if (activeIdx < 0 || activeIdx >= horses.length) activeIdx = 0;

  var countEl = root.querySelector('[data-savvy-sugg-count]');
  var subEl = root.querySelector('[data-savvy-sugg-sub]');
  var tabsEl = root.querySelector('[data-savvy-sugg-tabs]');
  var listEl = root.querySelector('[data-savvy-sugg-list]');
  var footEl = root.querySelector('[data-savvy-sugg-foot]');
  var toastEl = root.querySelector('[data-savvy-sugg-toast]');

  function escapeText(s) {
    return String(s == null ? '' : s).replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;');
  }
  function escapeAttr(s) {
    return escapeText(s).replace(/"/g,'&quot;').replace(/'/g,'&#39;');
  }
  function totalPickCount() {
    return horses.reduce(function(sum, h){ return sum + (h.picks ? h.picks.length : 0); }, 0);
  }
  function updateBarCopy() {
    if (horses.length === 1) {
      var one = horses[0];
      countEl.textContent = 'for ' + one.name + ' · ' + one.picks.length + ' product' + (one.picks.length === 1 ? '' : 's');
    } else {
      var names = horses.map(function(h){ return h.name; }).join(', ');
      countEl.textContent = 'for ' + names + ' · ' + totalPickCount() + ' products';
    }
    subEl.textContent = horses.length === 1
      ? 'For ' + horses[0].name + ' · based on your quiz'
      : horses.length + ' horses · based on your quizzes';
  }

  function renderTabs() {
    if (horses.length <= 1 && horses.length >= MAX_HORSES) {
      tabsEl.classList.remove('has-tabs');
      tabsEl.innerHTML = '';
      return;
    }
    tabsEl.classList.add('has-tabs');
    var parts = [];
    if (horses.length > 1) {
      horses.forEach(function(h, i) {
        parts.push('<button type="button" class="savvy-sugg-tab' + (i === activeIdx ? ' is-active' : '') + '" data-savvy-sugg-tab="' + i + '">' + escapeText(h.name) + '</button>');
      });
    }
    if (horses.length < MAX_HORSES) {
      parts.push('<a class="savvy-sugg-tab-add" href="' + QUIZ_URL + '">+ Add horse</a>');
    }
    tabsEl.innerHTML = parts.join('');
  }

  function renderList() {
    var active = horses[activeIdx];
    if (!active || !Array.isArray(active.picks)) { listEl.innerHTML = ''; return; }
    listEl.innerHTML = active.picks.map(function(p) {
      var role = (p.role || 'support');
      var roleLabel = role === 'core' ? 'Primary' : (role === 'addon' ? 'Also worth adding' : 'Support');
      var img = p.imageUrl
        ? '<div class="savvy-sugg-thumb"><img src="' + escapeAttr(p.imageUrl) + '" alt="' + escapeAttr(p.title || '') + '" loading="lazy"></div>'
        : '<div class="savvy-sugg-thumb"></div>';
      var addBtn = (p.variantId && p.variantAvailable !== false)
        ? '<button type="button" class="savvy-sugg-btn savvy-sugg-btn-add" data-savvy-sugg-add="' + p.variantId + '" data-savvy-sugg-handle="' + escapeAttr(p.handle) + '"><span class="savvy-sugg-btn-label">Add</span></button>'
        : '';
      return '<div class="savvy-sugg-item">' +
        img +
        '<div class="savvy-sugg-meta">' +
          '<div class="savvy-sugg-role" data-role="' + role + '">' + roleLabel + '</div>' +
          '<div class="savvy-sugg-title">' + escapeText(p.title || p.handle) + '</div>' +
          (p.price ? '<div class="savvy-sugg-price">' + escapeText(p.price) + '</div>' : '') +
        '</div>' +
        '<div class="savvy-sugg-actions">' +
          '<a href="/products/' + encodeURIComponent(p.handle) + '" class="savvy-sugg-btn savvy-sugg-btn-view">View</a>' +
          addBtn +
        '</div>' +
      '</div>';
    }).join('');
  }

  function renderFoot() {
    var parts = [
      '<a href="#" class="savvy-sugg-foot-lnk" data-savvy-sugg-print>Save / print</a>',
      '<a href="' + QUIZ_URL + '" class="savvy-sugg-foot-lnk">Retake quiz</a>',
    ];
    if (horses.length < MAX_HORSES) {
      parts.push('<a href="' + QUIZ_URL + '" class="savvy-sugg-foot-lnk">Add another horse</a>');
    }
    footEl.innerHTML = parts.join('');
  }

  // Print-friendly view — opens in a new tab. Each product has a QR code
  // (generated via api.qrserver.com — no library needed) linking straight to
  // its Shopify PDP so someone reading the print-out can scan to the product
  // on their phone.
  function openPrintView() {
    var horse = horses[activeIdx];
    if (!horse) return;
    /* Always point QR codes and printed URLs at the live storefront — the
       print-out lives on paper long after the current session, and a preview
       URL would 404 for anyone scanning it later. */
    var origin = 'https://savvyhorseproducts.com';
    var dateStr = new Date().toLocaleDateString(undefined, { year: 'numeric', month: 'long', day: 'numeric' });

    function esc(s) {
      return String(s == null ? '' : s).replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;').replace(/"/g,'&quot;');
    }
    function roleLabel(r) {
      return r === 'core' ? 'Primary' : (r === 'addon' ? 'Also worth adding' : 'Support');
    }

    var cards = horse.picks.map(function(p) {
      var url = origin + '/products/' + encodeURIComponent(p.handle);
      var qr = 'https://api.qrserver.com/v1/create-qr-code/?size=160x160&margin=4&data=' + encodeURIComponent(url);
      var img = p.imageUrl
        ? '<div class="pv-img"><img src="' + esc(p.imageUrl) + '" alt=""></div>'
        : '<div class="pv-img pv-img-placeholder"></div>';
      return '<article class="pv-card">' +
        img +
        '<div class="pv-meta">' +
          '<div class="pv-role">' + esc(roleLabel(p.role)) + '</div>' +
          '<h2 class="pv-title">' + esc(p.title || p.handle) + '</h2>' +
          (p.price ? '<div class="pv-price">' + esc(p.price) + '</div>' : '') +
          (p.soft ? '<p class="pv-soft">' + esc(p.soft) + '</p>' : '') +
          '<div class="pv-url">' + esc(url) + '</div>' +
        '</div>' +
        '<div class="pv-qr">' +
          '<img src="' + qr + '" alt="Scan to view">' +
          '<div class="pv-qr-caption">Scan to view</div>' +
        '</div>' +
      '</article>';
    }).join('');

    var html =
      '<!doctype html><html lang="en"><head><meta charset="utf-8">' +
      '<meta name="viewport" content="width=device-width,initial-scale=1">' +
      '<title>Savvy Supplement Suggestions for ' + esc(horse.name) + '</title>' +
      '<style>' +
        'body { font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif; color: #262626; max-width: 780px; margin: 32px auto; padding: 0 24px; line-height: 1.5; }' +
        '.pv-topbar { display: flex; justify-content: flex-end; gap: 8px; margin-bottom: 12px; }' +
        '.pv-btn { background: #469C9A; color: #fff; padding: 8px 16px; border-radius: 4px; border: none; font: inherit; cursor: pointer; text-decoration: none; display: inline-block; }' +
        '.pv-btn.secondary { background: #fff; color: #262626; border: 1px solid #d0d8d7; }' +
        '.pv-header { border-bottom: 3px solid #469C9A; padding-bottom: 12px; margin-bottom: 20px; }' +
        '.pv-header h1 { font-size: 24px; margin: 0 0 4px; font-weight: 500; }' +
        '.pv-header .pv-meta-line { font-size: 13px; color: #666; }' +
        '.pv-intro { font-size: 14px; margin: 0 0 20px; }' +
        '.pv-cards { display: flex; flex-direction: column; gap: 16px; }' +
        '.pv-card { display: grid; grid-template-columns: 120px 1fr 120px; gap: 20px; padding: 16px; border: 1px solid #e5edec; border-radius: 4px; page-break-inside: avoid; }' +
        '.pv-card:first-of-type { border-left: 3px solid #469C9A; }' +
        '.pv-img { width: 100%; aspect-ratio: 1/1; background: #f4f4f0; display: flex; align-items: center; justify-content: center; overflow: hidden; }' +
        '.pv-img img { width: 100%; height: 100%; object-fit: contain; padding: 6px; box-sizing: border-box; }' +
        '.pv-img-placeholder::after { content: "no image"; font-size: 10px; color: #999; }' +
        '.pv-meta { min-width: 0; }' +
        '.pv-role { font-size: 10px; text-transform: uppercase; letter-spacing: 0.14em; color: #2c7873; font-weight: 500; margin-bottom: 4px; }' +
        '.pv-title { font-size: 18px; font-weight: 500; margin: 0 0 4px; }' +
        '.pv-price { font-size: 14px; color: #4a4a4a; margin-bottom: 8px; }' +
        '.pv-soft { font-size: 13px; color: #444; margin: 0 0 6px; font-style: italic; }' +
        '.pv-url { font-size: 10px; color: #888; word-break: break-all; }' +
        '.pv-qr { text-align: center; }' +
        '.pv-qr img { width: 100%; max-width: 120px; height: auto; display: block; margin: 0 auto 4px; }' +
        '.pv-qr-caption { font-size: 11px; color: #666; }' +
        '.pv-footer { margin-top: 32px; padding-top: 16px; border-top: 1px solid #e5edec; font-size: 12px; color: #666; }' +
        '.pv-footer p { margin: 0 0 6px; }' +
        '@media print { .pv-topbar { display: none; } body { margin: 12mm; max-width: none; } .pv-card { break-inside: avoid; } }' +
      '</style>' +
      '</head><body>' +
      '<div class="pv-topbar">' +
        '<button class="pv-btn secondary" onclick="window.close()">Close</button>' +
        '<button class="pv-btn" onclick="window.print()">Print / Save PDF</button>' +
      '</div>' +
      '<div class="pv-header">' +
        '<h1>Savvy Supplement Suggestions for ' + esc(horse.name) + '</h1>' +
        '<div class="pv-meta-line">Generated ' + esc(dateStr) + ' · ' + horse.picks.length + ' product' + (horse.picks.length === 1 ? '' : 's') + '</div>' +
      '</div>' +
      '<p class="pv-intro">Based on your quiz, we\'d start with the products below. Scan the QR code on each card to open the product on your phone, or use the URL below the description.</p>' +
      '<div class="pv-cards">' + cards + '</div>' +
      '<div class="pv-footer">' +
        '<p><strong>Please note:</strong> This is general guidance based on the quiz answers, not a substitute for professional medical advice. If you have any concerns about your horse\'s health, please consult your veterinarian.</p>' +
        '<p>Savvy Horse Products · savvyhorseproducts.com · Retake the quiz any time at savvyhorseproducts.com/pages/premier-performance</p>' +
      '</div>' +
      '</body></html>';

    var w = window.open('', '_blank');
    if (!w) {
      showToast('Please allow pop-ups to print your suggestions.', false);
      return;
    }
    w.document.open();
    w.document.write(html);
    w.document.close();
  }

  function persistActive() {
    try {
      var current = JSON.parse(localStorage.getItem(STORAGE_KEY) || '{}');
      current.activeIndex = activeIdx;
      localStorage.setItem(STORAGE_KEY, JSON.stringify(current));
    } catch (e) {}
  }

  function setActive(i) {
    if (i < 0 || i >= horses.length) return;
    activeIdx = i;
    persistActive();
    renderTabs();
    renderList();
    updateBarCopy();
  }

  function setOpen(open) {
    root.setAttribute('data-savvy-sugg-open', open ? 'true' : 'false');
    document.body.style.overflow = open ? 'hidden' : '';
  }
  function showToast(msg, success) {
    toastEl.className = 'savvy-sugg-sheet-toast ' + (success ? 'is-success' : 'is-error');
    toastEl.textContent = msg;
    clearTimeout(window.__savvySuggToast);
    window.__savvySuggToast = setTimeout(function(){
      toastEl.className = 'savvy-sugg-sheet-toast'; toastEl.textContent = '';
    }, 4500);
  }

  // Initial render
  updateBarCopy();
  renderTabs();
  renderList();
  renderFoot();

  // Interactions
  root.querySelector('[data-savvy-sugg-open]').addEventListener('click', function(){ setOpen(true); });
  root.querySelector('[data-savvy-sugg-close]').addEventListener('click', function(){ setOpen(false); });
  root.querySelector('[data-savvy-sugg-scrim]').addEventListener('click', function(){ setOpen(false); });
  root.querySelector('[data-savvy-sugg-dismiss]').addEventListener('click', function(){
    try { sessionStorage.setItem(DISMISS_KEY, '1'); } catch (e) {}
    root.removeAttribute('data-savvy-sugg-active');
    setOpen(false);
  });

  tabsEl.addEventListener('click', function(ev){
    var t = ev.target.closest('[data-savvy-sugg-tab]');
    if (!t) return;
    ev.preventDefault();
    var i = parseInt(t.getAttribute('data-savvy-sugg-tab'), 10);
    if (Number.isFinite(i)) setActive(i);
  });

  footEl.addEventListener('click', function(ev){
    var print = ev.target.closest('[data-savvy-sugg-print]');
    if (!print) return;
    ev.preventDefault();
    openPrintView();
  });

  // Add-to-cart via Shopify's async endpoint.
  listEl.addEventListener('click', function(ev){
    var btn = ev.target.closest('[data-savvy-sugg-add]');
    if (!btn) return;
    ev.preventDefault();
    var variantId = btn.getAttribute('data-savvy-sugg-add');
    var label = btn.querySelector('.savvy-sugg-btn-label');
    var original = label ? label.textContent : 'Add';
    if (label) label.textContent = 'Adding…';
    btn.disabled = true;
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: 1 })
    })
      .then(function(r){ if (!r.ok) throw new Error('HTTP ' + r.status); return r.json(); })
      .then(function(){
        if (label) label.textContent = '✓ Added';
        btn.classList.add('is-added');
        showToast('Added to cart.', true);
        document.dispatchEvent(new CustomEvent('cart:refresh'));
        document.dispatchEvent(new CustomEvent('cart:updated'));
        document.dispatchEvent(new CustomEvent('cart:build'));
        setTimeout(function(){
          if (label) label.textContent = original;
          btn.disabled = false;
          btn.classList.remove('is-added');
        }, 2500);
      })
      .catch(function(){
        if (label) label.textContent = original;
        btn.disabled = false;
        showToast('Could not add. Please try the product page.', false);
      });
  });

  document.addEventListener('keydown', function(ev){
    if (ev.key === 'Escape' && root.getAttribute('data-savvy-sugg-open') === 'true') setOpen(false);
  });
  }
})();
